import styled, { css } from 'styled-components';
import { colors } from '../../variables/colors.js';
import { transitions } from '../../variables/transitions.js';
import { deviceWidths } from '../../variables/widths.js';

var Breadcrumbs = styled.ol.withConfig({
  displayName: "style__Breadcrumbs",
  componentId: "sc-q30jvh-0"
})(["color:", ";line-height:20px;padding:5px 0 5px 10px;font-size:14px;@media (min-width:", "){padding:8px 0 8px 16px;}@media (min-width:", "){padding-left:0;}"], colors.darkGray, deviceWidths.tablet, deviceWidths.desktop);
var Breadcrumb = styled.li.withConfig({
  displayName: "style__Breadcrumb",
  componentId: "sc-q30jvh-1"
})(["display:inline-block;padding-right:6px;@media (max-width:", "){", "}&:last-of-type{pointer-events:none;a{color:", ";}.sg-breadcrumbs__arrow-icon{display:none;}}&:not(:last-of-type){cursor:pointer;}.sg-breadcrumbs__arrow-icon{color:", ";cursor:default;display:inline-block;margin-left:8px;margin-right:8px;height:8px;width:8px;}"], deviceWidths.tabletMax, function (props) {
  return props.desktopOnly && css(["display:none;"]);
}, colors.darkGrayL1, colors.darkGray);
var Link = styled.a.withConfig({
  displayName: "style__Link",
  componentId: "sc-q30jvh-2"
})(["border-bottom:1px solid transparent;color:", ";transition:border-color ", ",color ", ";.no-touch &:hover{@media (min-width:", "){border-color:", ";cursor:pointer;}}"], colors.darkGray, transitions["default"], transitions["default"], deviceWidths.tablet, colors.darkGray);

export { Breadcrumb, Breadcrumbs, Link };
//# sourceMappingURL=style.js.map
